<p-dialog
  [(visible)]="dialogVisible"
  [blockScroll]="false"
  [draggable]="false"
  [header]="'misc.overview.sequenceSubscription' | transloco"
  [modal]="true"
  styleClass="m-3"
>
  <div class="iotsens-divider mt-0"></div>
  <div class="flex flex-column">
    <div class="field">
      <label [for]="'emails'">{{ "attribute.email" | transloco }}(s):</label>
      <p-chips
        (onAdd)="validateEmail($event)"
        (onRemove)="modified = true"
        *ngIf="!loading"
        [(ngModel)]="listEmails"
        [allowDuplicate]="false"
        [disabled]="loading"
        [placeholder]="'misc.inputEmailSubscription' | transloco"
        class="p-fluid"
        inputId="emails"
        separator=","
      >
        <ng-template let-item pTemplate="item">
          <i aria-hidden="true" class="pi pi-inbox mr-2"></i>{{ item }}
        </ng-template>
      </p-chips>
      <p-skeleton class="p-fluid" *ngIf="loading" height="32.16px"></p-skeleton>
    </div>
    <div
      class="flex flex-wrap align-items-center justify-content-between gap-2"
    >
      <div class="flex align-items-center gap-2">
        <em class="pi pi-info-circle"></em>
        <p class="w-full">{{ "info.subscription" | transloco }}</p>
      </div>
      <div class="flex flex-wrap align-items-center gap-2">
        <p-button (click)="clearList()" [disabled]="loading">
          {{ "misc.clearEmailList" | transloco }}
        </p-button>
        <p-button (click)="updateSubscription()" [disabled]="loading || !modified" styleClass="ml-2">
          {{ "misc.updateAlarmSubscription" | transloco }}
        </p-button>
      </div>
    </div>
  </div>
</p-dialog>
